import React, {MouseEvent} from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {services} from '../../../../application/service/services';
import {SelectMode, Table} from '../../../../component/table/Table';
import {getDashboardResolvedParams} from '../../../state/selectors/dashboardSelector';
import './tableViz.scss';
import {ClickableViz} from "../ClickableViz";
import {
    AbstractTableVizComponent,
    AbstractTableVizProps,
    AbstractTableVizStateProps,
    TableItem
} from "./AbstractTableViz";
import {DataRenderer} from "../../../../component/table/DataRenderer";


interface TableVizStateProps extends AbstractTableVizStateProps {

};

interface TableVizProps extends AbstractTableVizProps {

}


export class TableVizComponent extends AbstractTableVizComponent<TableVizProps> {
    private dataRenderer: DataRenderer;

    constructor(props: TableVizProps, context: any) {
        super(props, context);
        this.dataRenderer = new DataRenderer(this.props.viz, this.props.t);
    }

    getColumnRender(colName: string) {
        return this.dataRenderer.dataColumnRenderers[colName];
    }

    state: TableVizStateProps = {
        ...this.state
    };


    isExpanded(expandedValues: Array<any>, rowValue: any): boolean {
        return expandedValues.find(value => value.field === rowValue.field && value.fieldValue === rowValue.fieldValue) != null;
    }

    onSelectionChange(selection: Array<any>, newlySelectedItem: any, event: MouseEvent) {
        this.state.clickItem = newlySelectedItem;
        const {t, viz} = this.props;
        const field = services.getFieldsService().getField(newlySelectedItem.field);
        const fieldValue = services.getFieldsService().findFieldValue(field.name, newlySelectedItem.fieldValue);
        this.props.openFeedbacksPanel(this, fieldValue ? fieldValue.getLabel(t) : newlySelectedItem.fieldValue);
        event.preventDefault();
        event.stopPropagation();
    }
    protected getVolume(item: TableItem): { count: number, percent: number } {
        return item.data.find(
            x => x.name === "volume"
        )?.value;
    }

    renderTable(uiParams) {
        return <Table style={{width: "100%"}} color={uiParams.color}
                      expandable={this.containsLevels()}
                      separatorColor={uiParams.color}
                      dataset={this.getUiDataset()}
                      selectMode={SelectMode.ROW}
                      selectionChanged={this.onSelectionChange.bind(this)}
                      cellCanSelect={true}
                      onSort={this.onSort.bind(this)}
                      selectable={true}
                      isExpandedFunction={this.isExpanded}
                      highlight={
                          {
                              highlightedClassName: 'highlightedCell',
                              isHighlighted: (rowValue, rowIndex) => rowValue.highlighted
                          }
                      }
        />;
    }

}

const mapStateToProps = (state) => {
    return {
        dashboardResolvedParams: getDashboardResolvedParams(state),
        resolvedSpec: state.dashboard.resolvedSpec
    };
};


const mapDispatchToProps = (dispatch, props) => {
    return {
        openFeedbacksPanel: (viz: ClickableViz, panelTitle: string) => {
            dispatch.dashboard.openFeedBackPanel({viz, panelTitle});
        },
    }
};
export const TableViz = connect(mapStateToProps, mapDispatchToProps, null,
    {forwardRef: true})(withTranslation(undefined, {withRef: true})(TableVizComponent));

TableViz['getLabels'] = AbstractTableVizComponent.getLabels